import { observer } from "mobx-react";
import React, { useEffect } from "react";

import { useMainStore } from "@/contexts/Store";

import AttachedDocumentHeader from "../settings/AttachedDocumentHeader";
import AttachedDocumentRow from "../settings/AttachedDocumentRow";
import FileInput from "../shared/FileInput";
import Table from "../Table";

const headers = [
  {
    field_name: "upload_date",
    title: "Upload Date",
    width: 250,
  },
  {
    field_name: "owner",
    title: "Owner",
    width: 250,
  },
  {
    field_name: "description",
    title: "Description",
    width: 250,
  },
  {
    field_name: "filename",
    title: "Attachment",
    width: 250,
  },
];

type Props = {
  vendorID: string;
  isDisabled?: boolean;
};

function VendorDocuments({ vendorID, isDisabled }: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // Hooks

  useEffect(() => {
    mainStore.vendors.setCurrentVendor({});
    vendorID && mainStore.vendors.getVendorById(vendorID);
  }, [vendorID]);

  const recordID = mainStore.vendors.currentVendor.record?.id;

  useEffect(() => {
    if (recordID) {
      mainStore.attachedDocuments.index(recordID);
    }
  }, [recordID]);

  // Elements
  const renderHeaders = headers.map((header) => (
    <AttachedDocumentHeader
      key={header.field_name}
      width={header.width}
      title={header.title}
      fieldName={header.field_name}
    />
  ));

  const renderRows = mainStore.attachedDocuments.list.map(
    (attachedDocument) => (
      <AttachedDocumentRow
        // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'never'.
        key={attachedDocument.id}
        headers={headers}
        data={attachedDocument}
        model="Document"
        // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'never'.
        attachedDocumentID={attachedDocument.id}
        recordID={recordID}
        isLocked={isDisabled}
      />
    ),
  );

  // @ts-expect-error TS(7006) FIXME: Parameter 'files' implicitly has an 'any' type.
  async function handleAttachment(files) {
    if (!files || !Array.isArray(files) || files.length === 0) {
      return;
    }

    const params = {
      file: files[0],
    };
    await mainStore.attachedDocuments.create(recordID, params);
  }

  return (
    <Table>
      <div className="settings-wrap company-users-settings-container documents-vvd-wrap">
        <div className="settings-content-wrap">
          <div className="list-title-table">
            <ul>
              <div className="list-title-table-wrap">
                {renderHeaders}
                <span className="stretch-cell" />
              </div>
              {!isDisabled && <div className="list-title-table-block" />}
            </ul>
          </div>
          {!isDisabled && (
            <div className="add-new-user" data-testid="add-new-document">
              <FileInput
                handleAttachment={(files) => handleAttachment(files)}
                trigger={
                  <button className="add-new-attached-document">
                    Add New Document +
                  </button>
                }
                triggerStyles={{ width: "100%" }}
                centerPositioning
              />
            </div>
          )}
          {renderRows}
        </div>
      </div>
    </Table>
  );
}

export default observer(VendorDocuments);
